window.tinymce.PluginManager.add('store_item', function(editor) {
    editor.addButton('store_item', {
        tooltip: 'Store Item',
        onclick: () => {
            const uuid = window.uuidv4();

            const idElement = document.createElement('span');
            idElement.classList.add('store-item-id');
            idElement.innerText = 'ID';

            const element = document.createElement('span');
            element.classList.add('store-item');
            element.innerHTML = `<img data-mce-placeholder src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=' onload='window.renderStoreItemHelper("${uuid}");'/>`;
            element.id = `store-item-${uuid}`;
            element.appendChild(idElement);

            editor.selection.setNode(element);
        },
        icon: 'custom fa-shopping-cart',
    });
});
